import { render } from "./editDealerForm.vue?vue&type=template&id=4ed3a990&scoped=true"
import script from "./editDealerForm.vue?vue&type=script&lang=js"
export * from "./editDealerForm.vue?vue&type=script&lang=js"

import "./editDealerForm.vue?vue&type=style&index=0&id=4ed3a990&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed3a990"]])

export default __exports__